// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import useScrollOnListItemFocus from '../../lists/useScrollOnListItemFocus';

// Styles
import './SearchResultListItem.scss';

const SearchResultListItem = (props) => {
    const { children, focusedIndex, index } = props;

    const [focused, listItemRef] = useScrollOnListItemFocus({ focusedIndex, index });

    return (
        <li tabIndex={0} ref={listItemRef} className={classNames('SearchResultListItem', { focused })}>
            {children}
        </li>
    );
};

SearchResultListItem.propTypes = {
    setFocusIndex: PropTypes.func,
    focusInput: PropTypes.func,
    onDown: PropTypes.func,
    onUp: PropTypes.func,
    focusedIndex: PropTypes.number,
    index: PropTypes.number,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default SearchResultListItem;
